import { render } from "./PlayView.vue?vue&type=template&id=3b3c01b9&scoped=true&ts=true"
import script from "./PlayView.vue?vue&type=script&lang=ts"
export * from "./PlayView.vue?vue&type=script&lang=ts"

import "./PlayView.vue?vue&type=style&index=0&id=3b3c01b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3c01b9"]])

export default __exports__